module.exports = __webpack_public_path__ + "static/media/icon_entered.fae28ed6.svg";